import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Image from '@nubank/www-latam-commons/components/Image/Image';

import { StyledIcon } from './styles/Icon';

const TOPIC_KEYS = [
  'TOPIC_1',
  'TOPIC_2',
  'TOPIC_3',
];

function SectionCustomerTarget() {
  return (
    <Box
      display="grid"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
      paddingHorizontal={{ xs: '6x', md: 40, lg: 56 }}
      gridTemplateColumns={{ xs: 'repeat(4, 1fr)', md: 'repeat(6,1fr)', lg: 'repeat(12,1fr)' }}
      gridTemplateRows={{ lg: 'auto auto 1fr' }}
      gridColumnGap={{ xs: '4x', md: '8x' }}
      gridTemplateAreas={{
        xs: `
          "title title title title"
          "text text text text"
          "topics topics topics topics"
          "image image image image"
        `,
        md: `
          "title title title title title ."
          "image image image image image image"
          "text text text topics topics topics"
      `,
        lg: `
          ". image image image image . title title title title title ."
          ". image image image image . text text text text text ."
          ". image image image image . topics topics topics topics topics ."
      `,
      }}
    >
      <Box gridArea="title">
        <Typography
          intlKey="INSURANCE.CUSTOMER_TARGET.TITLE"
          variant="title"
          gutterBottom={{ xs: 1.5, md: 2, lg: 1.5 }}
        />
      </Box>
      <Box gridArea="text">
        <Typography
          intlKey="INSURANCE.CUSTOMER_TARGET.TEXT"
          variant="subtitle"
          gutterBottom={{ xs: 1.5, md: 0, lg: 1 }}
        />
      </Box>
      <Box
        gridArea="topics"
        display="grid"
        gridRowGap={{ xs: '4x' }}
        marginBottom={{ xs: '12x', md: '0x' }}
      >
        {TOPIC_KEYS.map(key => (
          <Box key={`topic-target-${key}`} display="grid" gridTemplateColumns="auto 1fr" gridColumnGap="3x">
            <StyledIcon name="arrow-down-right" />
            <Typography
              tag="p"
              variant="subtitle"
              intlKey={`INSURANCE.CUSTOMER_TARGET.${key}`}
            />
          </Box>
        ))}
      </Box>
      <Box
        gridArea="image"
        marginBottom={{ md: '8x', lg: '0x' }}
        display="flex"
        justifyContent="center"
      >
        <Image
          loading="lazy"
          srcSet={{
            xs: {
              '1x': 'pregnant-woman/pregnant-woman@mobile@1x.jpg',
              '2x': 'pregnant-woman/pregnant-woman@mobile@2x.jpg',
              '3x': 'pregnant-woman/pregnant-woman@mobile@3x.jpg',
            },
            md: {
              '1x': 'pregnant-woman/pregnant-woman@tablet@1x.jpg',
              '2x': 'pregnant-woman/pregnant-woman@tablet@2x.jpg',
              '3x': 'pregnant-woman/pregnant-woman@tablet@3x.jpg',
            },
            lg: {
              '1x': 'pregnant-woman/pregnant-woman@desktop@1x.jpg',
              '2x': 'pregnant-woman/pregnant-woman@desktop@2x.jpg',
              '3x': 'pregnant-woman/pregnant-woman@desktop@3x.jpg',
            },
          }}
          altIntlKey="INSURANCE.CUSTOMER_TARGET.IMAGE_ALT"
        />
      </Box>
    </Box>
  );
}

export default React.memo(SectionCustomerTarget);
